import { ThemeStore } from "../../../library/stores/Theme";
import SVGInject from "@iconfu/svg-inject";
(window as any).SVGInject = SVGInject;
new ThemeStore();
